module.exports = __webpack_public_path__ + "static/media/share-green.87dad08a.svg";